var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("a", { ref: "attachmentA" }),
      _vm._v(" "),
      _c("stepheader", { attrs: { step: _vm.step } }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "body current",
          attrs: {
            id: "wizard2-p-0",
            role: "tabpanel",
            "aria-labelledby": "wizard2-h-0",
            "aria-hidden": "false",
          },
        },
        [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-12" },
              _vm._l(_vm.danni, function (danno, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "selectgroup-pills" },
                  [
                    _c(
                      "label",
                      {
                        staticClass: "selectgroup-item",
                        staticStyle: { display: "block" },
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.danniSelezionati,
                              expression: "danniSelezionati",
                            },
                          ],
                          staticClass: "selectgroup-input",
                          attrs: {
                            type: "checkbox",
                            name: "value",
                            checked: "",
                          },
                          domProps: {
                            value: danno,
                            checked: Array.isArray(_vm.danniSelezionati)
                              ? _vm._i(_vm.danniSelezionati, danno) > -1
                              : _vm.danniSelezionati,
                          },
                          on: {
                            change: function ($event) {
                              var $$a = _vm.danniSelezionati,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = danno,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.danniSelezionati = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.danniSelezionati = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.danniSelezionati = $$c
                              }
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "selectgroup-button text-start" },
                          [_vm._v(_vm._s(danno.descrizione))]
                        ),
                      ]
                    ),
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _vm.step.showAnomalia
              ? _c("div", { staticClass: "col-12" }, [
                  _c(
                    "label",
                    { staticClass: "form-label", attrs: { for: "anomalia" } },
                    [
                      _vm._v(
                        "Indicare eventuali anomalie diverse da quelle indicate sopra:\n          "
                      ),
                      _vm.step.required
                        ? _c("span", { staticClass: "tx-danger" }, [
                            _vm._v("*"),
                          ])
                        : _vm._e(),
                    ]
                  ),
                  _vm._v(" "),
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.ticket.anomalia,
                        expression: "ticket.anomalia",
                      },
                    ],
                    staticClass: "form-control",
                    domProps: { value: _vm.ticket.anomalia },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.ticket, "anomalia", $event.target.value)
                      },
                    },
                  }),
                ])
              : _vm._e(),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("buttons", {
        attrs: { buttons: _vm.step.buttons },
        on: { action: _vm.fireaction },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }